import { render } from "./FormInfo.vue?vue&type=template&id=e66942e8&scoped=true"
import script from "./FormInfo.vue?vue&type=script&lang=js"
export * from "./FormInfo.vue?vue&type=script&lang=js"

import "./FormInfo.vue?vue&type=style&index=0&id=e66942e8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-e66942e8"

export default script